import styled from 'styled-components';

import theme from '../../../assets/theme';
import { PollOptions } from '../../SlideComponents/slide.types';
import { letterFor } from './letterFor';

type Props = {
  pollOptions: PollOptions[];
};

// Same layout constants as MultipleChoiceBadgeOverlay so the letter chip
// centres horizontally on the same column the static bar / label uses.
const SLIDE_PADDING_RATIO = 0.05;
const GAP_RATIO = 10 / 1920;
// Sits just above the option labels (createPollElements puts the label
// at 78% from top), close enough to read as a chip on the label.
const LETTER_TOP_RATIO = 0.73;

const MultipleChoiceLetterOverlay = ({ pollOptions }: Props) => {
  const count = pollOptions.length;
  if (!count) return null;

  return (
    <Overlay>
      {pollOptions.map((option, index) => {
        const columnLeftPct =
          (SLIDE_PADDING_RATIO + (index * (1 - 2 * SLIDE_PADDING_RATIO)) / count) * 100;
        const columnWidthPct =
          ((1 - 2 * SLIDE_PADDING_RATIO) / count - 2 * GAP_RATIO) * 100;

        return (
          <ColumnContainer
            key={option.id}
            style={{
              left: `${columnLeftPct}%`,
              width: `${columnWidthPct}%`,
            }}
          >
            <LetterChip style={{ top: `${LETTER_TOP_RATIO * 100}%` }}>
              {letterFor(index)}
            </LetterChip>
          </ColumnContainer>
        );
      })}
    </Overlay>
  );
};

const Overlay = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 2;
`;

const ColumnContainer = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
`;

const LetterChip = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: ${theme.colors.background};
  color: ${theme.colors.black};
  border: 1px solid ${theme.colors.greyLight};
  font-weight: 900;
  font-size: 28px;
  letter-spacing: 0.02em;
`;

export default MultipleChoiceLetterOverlay;
